import { render, staticRenderFns } from "./PlayerPendingAddDataInputRewardLetter.vue?vue&type=template&id=6c2f31f6&"
import script from "./PlayerPendingAddDataInputRewardLetter.vue?vue&type=script&lang=js&"
export * from "./PlayerPendingAddDataInputRewardLetter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports